import { IFileItem, isFileItem } from '../../types/api/FileItem';
import { ISonURL } from '../../types/IUrl';
import {
  CategoriesParam,
  CheckBoxParam,
  ComboBoxMultiselectParam,
  ComboBoxParam,
  DateParam,
  FileDataParam,
  HiddenParam,
  SonForm,
  TextAreaParam,
  TextParam,
} from '../../_lib/Form2';

export type SharedFileForms = {
  delete?: SharedFilesDeleteForm;
  move?: SharedFilesMoveForm;
  edit?: SonForm<
    | TextParam<'title'>
    | HiddenParam<'fileReferenceId'>
    | CheckBoxParam<'importantChange'>
    | TextAreaParam<'changeComment'>
    | FileDataParam<'fileData'>
    | TextAreaParam<'description'>
    | TextParam<'author'>
    | DateParam<'contentDate'>
    | ComboBoxMultiselectParam<'keywords', any>
    | CategoriesParam<'categories'>
  >;
};

export type SharedFilesMoveForm = SonForm<
  HiddenParam<'files'> | HiddenParam<'directories'> | ComboBoxParam<'targetPageId'>
>;

export type SharedFilesDeleteForm = SonForm<HiddenParam<'files'> | HiddenParam<'directories'>>;

export type SharedFilesPrepareMultiDownloadUrl = SonForm<HiddenParam<'files'> | HiddenParam<'directories'>>;

export type SharedDirectory = { pageId: string; pageLink: ISonURL; editDate: string; editedBy?: ISonURL };

export type SharedFile = IFileItem<SharedFileForms> & { infoUrl: string };

export type SharedFileOrDirectory = SharedFile | SharedDirectory;

/**
 * data attributes on row elements to identify type and id
 */
export type SharedFilesDataRowEntities = {
  dataSharedEntityType: 'file' | 'directory';
  dataSharedEntityId: string;
};

export const SHARED_FILES_TABLE_ID = 'shared-files-table';

export const SHARED_FILES_PARAM_FILES = 'files';
export const SHARED_FILES_PARAM_DIRECTORIES = 'directories';
export const isSharedFile = (item: SharedFileOrDirectory): item is SharedFile => isFileItem(item);

// required for sorting, as dont have a real mapping for directories
export const getFileExtension = (item: SharedFileOrDirectory): string =>
  isSharedFile(item) ? item.fileExtension.toLowerCase() : 'Ordner'.toLowerCase();
